import { useEffect, useState } from 'react';

const Timer = ({
  onFinish,
  timer = 30,
}: {
  onFinish: () => void;
  timer?: number;
}) => {
  const [countdown, setCountdown] = useState<number | null>(null);

  // countdown
  useEffect(() => {
    setCountdown(timer);

    const timerInterval = setInterval(() => {
      setCountdown((prev) => (prev !== null && prev > 0 ? prev - 1 : 0));
    }, 1000);

    const closeTimer = setTimeout(() => {
      onFinish();
    }, timer * 1000);

    return () => {
      clearTimeout(closeTimer);
      clearInterval(timerInterval);
    };
  }, [onFinish]);

  return countdown;
};

export default Timer;
